import { DateTime } from 'luxon';

const getDate = dateStart => {
    const luxonDateStart = DateTime.fromISO(dateStart);

    return luxonDateStart.toFormat('d MMMM');
}

const getDateWithTime = (date, ttl = '') => {
    let luxonDate = DateTime.fromISO(date);

    if (ttl) {
        luxonDate = luxonDate.plus(ttl);
    }

    return luxonDate.toFormat('d MMMM, yyyy T');
}

const isSameDate = (a, b) => {
    const dateStart = DateTime.fromISO(a);
    const dateFinish = DateTime.fromISO(b);
  
    return dateStart.hasSame(dateFinish, 'day') && dateStart.hasSame(dateFinish, 'month') && dateStart.hasSame(dateFinish, 'year');
}

const getShortDate = dateStart => {
    const luxonDateStart = DateTime.fromISO(dateStart);

    return luxonDateStart.toFormat('d LLL');
}

const getDateWithYear = dateStart => {
    const luxonDateStart = DateTime.fromISO(dateStart);

    return luxonDateStart.toFormat('d MMMM, yy');
}

const isValidDate = (year, monthIndex, day) => {
    const date = new Date(year, monthIndex, day);

    return date.getDate() === day && date.getMonth() === monthIndex && date.getFullYear() === year;
}

const getExpiryTimestamp = (createdAt, ttl) => {
    const luxonDate = DateTime.fromISO(createdAt);

    return luxonDate.toMillis() + ttl;
}

const untilDate = date => {
    const luxonDate = DateTime.fromISO(date);

    return DateTime.now().until(luxonDate);
}

const untilDateWithTtl = (date, ttl) => {
    const luxonDate = DateTime.fromISO(date).plus(ttl);

    return DateTime.now().until(luxonDate);
}

function timeAgo(date) {
    const now = DateTime.now();
    const past = DateTime.fromISO(date);
  
    const diffInSeconds = now.diff(past, 'seconds').seconds;

    if (diffInSeconds < 60) return `${Math.floor(diffInSeconds)} sec. ago`;

    if (diffInSeconds < 3600) {
        return `${Math.floor(diffInSeconds / 60)} min. ago`;
    }

    if (diffInSeconds < 86400) {
        return `${Math.floor(diffInSeconds / 3600)} h. ago`;
    }
  
    const days = Math.floor(diffInSeconds / 86400);

    return `${days || 1} day${days > 1 ? 's' : ''} ago`;
}

export {
    getDate,
    getShortDate,
    isValidDate,
    isSameDate,
    getExpiryTimestamp,
    getDateWithTime,
    getDateWithYear,
    untilDate,
    untilDateWithTtl,
    timeAgo
}
